/**
 * Bar 패널 전용 집계 간격 계산 — 밀도 게이트 2026-07-27에서 채택된 여유형(~24묶음).
 *
 * 백엔드 자동 step(RecommendedStepInterval)은 차트 종류와 무관하게 화면당 ~300
 * 포인트를 목표로 하는데, 그룹 배치 막대는 한 시각당 시리즈 수만큼 막대가 서므로
 * 그 밀도로는 15분 조회부터 읽을 수 없다. 그래서 Bar 패널 쿼리에만 이 값을
 * stepInterval로 명시 전송해 시각 묶음을 최대 BAR_MAX_GROUPS개로 묶는다.
 * (echartsLib/uPlot 양쪽에서 그리는 패널의 쿼리 단계 공통 정책이라 chartCommon 소속)
 */

/** 화면당 막대 묶음(시각) 수 상한. 목표는 ~24, 사다리 반올림으로 최대 28까지 허용 */
export const BAR_MAX_GROUPS = 28;

/** 사람이 읽기 좋은 간격 사다리(초): 1·2·5·10·15·30분, 1·2·3·6·12시간, 1·2·7일 */
const STEP_LADDER_SECONDS = [
	60, 120, 300, 600, 900, 1800, 3600, 7200, 10800, 21600, 43200, 86400, 172800,
	604800,
];

export function getBarPanelStepInterval(
	startMs: number,
	endMs: number,
): number {
	const rangeSeconds = (endMs - startMs) / 1000;

	if (!Number.isFinite(rangeSeconds) || rangeSeconds <= 0) {
		return STEP_LADDER_SECONDS[0];
	}

	const minStep = rangeSeconds / BAR_MAX_GROUPS;
	const matched = STEP_LADDER_SECONDS.find((step) => step >= minStep);

	return matched ?? STEP_LADDER_SECONDS[STEP_LADDER_SECONDS.length - 1];
}
